import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    IMaterialConsumption,
    IMaterialConsumptionCreateRequest,
    IMaterialConsumptionUpdateRequest,
} from '../interfaces/garments/materialConsumption.interface';

const headers = () => AuthService.getAuthHeader();

export const MaterialConsumptionService = {
    list: async (institutionId: string, buyerOrderId: string): Promise<IMaterialConsumption[]> => {
        const res = await axios.get(ENDPOINTS.MATERIAL_CONSUMPTION.LIST(institutionId, buyerOrderId), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: IMaterialConsumptionCreateRequest): Promise<IMaterialConsumption> => {
        const res = await axios.post(ENDPOINTS.MATERIAL_CONSUMPTION.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    update: async (institutionId: string, id: string, request: IMaterialConsumptionUpdateRequest): Promise<IMaterialConsumption> => {
        const res = await axios.put(ENDPOINTS.MATERIAL_CONSUMPTION.UPDATE(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.MATERIAL_CONSUMPTION.DELETE(institutionId, id), { headers: headers() });
    },
};

export default MaterialConsumptionService;
